import React from "react";
import LegalPageLayout from "@/legal/LegalPageLayout";
import { BRAND } from "@/legal/legalConfig";

export default function Cookies() {
  return (
    <LegalPageLayout title="Cookie-Richtlinie" lastUpdated="08.02.2026" testid="cookies-page">
      <h2>1. Was sind Cookies?</h2>
      <p>
        Cookies sind kleine Textdateien, die beim Besuch einer Website im Browser gespeichert werden. Daneben verwenden
        moderne Web-Anwendungen auch den lokalen Speicher des Browsers (localStorage), der ähnlich funktioniert. Beide
        sind technisch notwendig, um z.B. eine bestehende Anmeldung über den Seitenwechsel hinaus zu erhalten.
      </p>

      <h2>2. Welche Cookies / Speicher verwendet {BRAND.name}?</h2>
      <p>
        Wir verwenden aktuell <strong>ausschließlich technisch notwendige</strong> Cookies und localStorage-Einträge.
        Es findet kein Analyse- oder Marketing-Tracking statt. Wir setzen keine Cookies Dritter ein.
      </p>

      <div className="overflow-x-auto" data-testid="cookies-table">
        <table className="w-full text-sm border border-slate-200 rounded-md">
          <thead className="bg-slate-50">
            <tr>
              <th className="text-left p-2 border-b border-slate-200">Name</th>
              <th className="text-left p-2 border-b border-slate-200">Typ</th>
              <th className="text-left p-2 border-b border-slate-200">Zweck</th>
              <th className="text-left p-2 border-b border-slate-200">Speicherdauer</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-slate-100">
              <td className="p-2 font-mono text-xs">session_token</td>
              <td className="p-2">Cookie (HttpOnly)</td>
              <td className="p-2">Anmeldung / Session-Validierung</td>
              <td className="p-2">7 Tage</td>
            </tr>
            <tr>
              <td className="p-2 font-mono text-xs">revenioo_consent</td>
              <td className="p-2">localStorage</td>
              <td className="p-2">Speichert Ihre Cookie-Hinweis-Bestätigung</td>
              <td className="p-2">Bis zur Löschung durch Sie</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>3. Analyse- und Marketing-Cookies</h2>
      <p>
        {BRAND.name} setzt derzeit keine Analyse-, Tracking- oder Marketing-Cookies ein. Sollte sich dies künftig ändern,
        werden Sie vor der erstmaligen Verwendung ausdrücklich um Ihre Einwilligung gebeten.
      </p>

      <h2>4. Derzeit nicht aktive optionale Dienste</h2>
      <p>
        Google Analytics 4, Google Ads Conversion-Tracking, Google Tag Manager und Meta Pixel sind derzeit
        nicht aktiv eingebunden. Sollten diese Dienste künftig eingesetzt werden, erfolgt die Aktivierung
        erst nach ausdrücklicher Einwilligung über ein erweitertes Consent-Banner.
      </p>
      <p>
        Geplante optionale Dienste (sobald aktiviert):
      </p>
      <ul>
        <li>
          <strong>Google Analytics 4</strong> — typische Cookies: <code>_ga</code>, <code>_ga_*</code>;
          Anbieter: Google Ireland Ltd.; Zweck: Reichweitenmessung.
        </li>
        <li>
          <strong>Google Ads Conversion-Tracking</strong> — typische Cookies: <code>_gcl_au</code>, <code>IDE</code>;
          Anbieter: Google Ireland Ltd.; Zweck: Erfolgsmessung von Werbekampagnen.
        </li>
        <li>
          <strong>Google Tag Manager</strong> — Container ohne eigene Cookies; lädt nur Drittanbieter-Tags
          nach Ihrer Einwilligung.
        </li>
        <li>
          <strong>Meta Pixel / Meta Ads (Facebook &amp; Instagram)</strong> — typische Cookies: <code>_fbp</code>,
          <code>fr</code>; Anbieter: Meta Platforms Ireland Ltd.; Zweck: Conversion-Tracking, Custom Audiences, Re-Targeting.
        </li>
      </ul>
      <p>
        Sobald einer dieser Dienste aktiviert wird, ergänzen wir an dieser Stelle die konkreten Cookies,
        Speicherdauern und Drittlandstransfers und stellen Ihnen einen Consent-Banner mit Kategorie-Auswahl
        (Essenziell / Analyse / Marketing) zur Verfügung.
      </p>

      <h2>5. Verwaltung und Widerruf</h2>
      <p>
        Sie können Cookies jederzeit über die Einstellungen Ihres Browsers löschen oder das Setzen von Cookies blockieren.
        Bitte beachten Sie, dass die Funktionsfähigkeit der Plattform ohne technisch notwendige Cookies eingeschränkt ist
        (z.B. ist eine Anmeldung dann nicht möglich).
      </p>

      <h2>6. Rechtsgrundlage</h2>
      <p>
        Die Speicherung technisch notwendiger Cookies/localStorage-Einträge erfolgt auf Grundlage von § 25 Abs. 2 Nr. 2
        TTDSG bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem funktionsfähigen Online-Dienst).
        Sobald nicht-notwendige Cookies eingesetzt werden, holen wir hierfür Ihre Einwilligung gemäß § 25 Abs. 1 TTDSG ein.
      </p>
    </LegalPageLayout>
  );
}
